"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/* eslint-disable react/no-array-index-key */

/* eslint-disable @typescript-eslint/no-unsafe-member-access */

/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var swiper_1 = tslib_1.__importDefault(require("swiper"));

var Icon_1 = tslib_1.__importDefault(require("../../../Icon"));

require("swiper/dist/css/swiper.css");

var styles = tslib_1.__importStar(require("./Thumbs.style"));

var VideoPlayButton_1 = tslib_1.__importDefault(require("./VideoPlayButton"));

function Thumbs(_ref) {
  var className = _ref.className,
      _ref$imageUrls = _ref.imageUrls,
      imageUrls = _ref$imageUrls === void 0 ? [] : _ref$imageUrls,
      _ref$thumbsOptions = _ref.thumbsOptions,
      thumbsOptions = _ref$thumbsOptions === void 0 ? {} : _ref$thumbsOptions,
      _ref$topOptions = _ref.topOptions,
      topOptions = _ref$topOptions === void 0 ? {} : _ref$topOptions,
      _ref$initialSlide = _ref.initialSlide,
      initialSlide = _ref$initialSlide === void 0 ? 0 : _ref$initialSlide,
      hasVideo = _ref.hasVideo,
      onVideoClick = _ref.onVideoClick;
  react_1.useEffect(function () {
    var galleryThumbs = new swiper_1.default('.gallery-thumbs', Object.assign({
      spaceBetween: 10,
      centeredSlides: true,
      slideToClickedSlide: true,
      lazyLoading: true,
      keyboardControl: true,
      slidesPerView: 'auto',
      initialSlide: initialSlide
    }, topOptions));
    var galleryTop = new swiper_1.default('.gallery-top', Object.assign({
      spaceBetween: 10,
      lazyLoading: true,
      pagination: '.swiper-pagination',
      paginationType: 'fraction',
      nextButton: '.swiper-button-next',
      prevButton: '.swiper-button-prev',
      initialSlide: initialSlide
    }, thumbsOptions));

    if (galleryTop.params) {
      galleryTop.params.control = galleryThumbs;
    }

    if (galleryThumbs.params) {
      galleryThumbs.params.control = galleryTop;
    }

    return function () {
      if (galleryThumbs.destroy) {
        galleryThumbs.destroy(true, true);
      }

      if (galleryTop.destroy) {
        galleryTop.destroy(true, true);
      }
    };
  }, [imageUrls.length, initialSlide, thumbsOptions, topOptions]);
  return jsx_runtime_1.jsx("div", Object.assign({
    className: className,
    css: styles.swiperContainer
  }, {
    children: jsx_runtime_1.jsxs("div", Object.assign({
      css: styles.swiperContent
    }, {
      children: [jsx_runtime_1.jsxs("div", Object.assign({
        className: "swiper-container gallery-top",
        css: styles.galleryTop
      }, {
        children: [jsx_runtime_1.jsx("div", Object.assign({
          className: "swiper-wrapper",
          css: styles.swiperWrapper
        }, {
          children: imageUrls.map(function (imageUrl, index) {
            return jsx_runtime_1.jsxs("div", Object.assign({
              className: "swiper-slide"
            }, {
              children: [jsx_runtime_1.jsx("img", {
                src: "".concat(imageUrl, "?height=").concat(Math.ceil(670 * window.devicePixelRatio)),
                alt: "slide"
              }, void 0), hasVideo && index === 0 && jsx_runtime_1.jsx(VideoPlayButton_1.default, {
                onVideoClick: onVideoClick
              }, void 0)]
            }), "".concat(imageUrl.slice(0, 5), "-top").concat(index));
          })
        }), void 0), jsx_runtime_1.jsx("div", Object.assign({
          className: "swiper-button-next"
        }, {
          children: jsx_runtime_1.jsx(Icon_1.default, {
            name: "ic_narrowarrowright_xl_white",
            css: styles.swiperButtonNext
          }, void 0)
        }), void 0), jsx_runtime_1.jsx("div", Object.assign({
          className: "swiper-button-prev"
        }, {
          children: jsx_runtime_1.jsx(Icon_1.default, {
            name: "ic_narrowarrowleft_xl_white",
            css: styles.swiperButtonPrev
          }, void 0)
        }), void 0)]
      }), void 0), jsx_runtime_1.jsx("div", {
        className: "swiper-pagination",
        css: styles.pagination
      }, void 0), jsx_runtime_1.jsx("div", Object.assign({
        className: "swiper-container gallery-thumbs",
        css: styles.galleryThumbs
      }, {
        children: jsx_runtime_1.jsx("div", Object.assign({
          className: "swiper-wrapper"
        }, {
          children: imageUrls.map(function (imageUrl, index) {
            return jsx_runtime_1.jsx("div", {
              css: styles.galleryThumbsSlide("url(".concat(imageUrl, "?height=").concat(Math.ceil(120 * window.devicePixelRatio), ")")),
              className: "swiper-slide"
            }, "".concat(imageUrl.slice(0, 5), "-thumb").concat(index));
          })
        }), void 0)
      }), void 0)]
    }), void 0)
  }), void 0);
}

exports.default = Thumbs;